<template>
    <div class="client-card" :style="{ animationDelay: `${index * 100}ms` }">
        <div class="card-content">
            <div class="background-decoration"></div>

            <div class="avatar-container">
                <div class="avatar-circle">
                    <div class="avatar-inner">
                        <i class="fa fa-user fa-2x"></i>
                    </div>
                </div>
                <div class="avatar-glow"></div>
            </div>

            <div class="client-info">
                <h5 class="client-name">{{ client.nom_client }}</h5>
                <div class="client-badge">{{ client.total_dossier }}</div>
            </div>

            <div class="status-indicator"></div>
        </div>

        <div class="hover-overlay">
            <div class="hover-content">
                <i class="fa fa-eye fa-lg"></i>
                <span>Voir les dossiers</span>
                <p class="dossier-total text-white text-bold">{{ client.total_dossier }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        client: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style scoped>
/* GENERAL CARD STYLING */
.client-card {
    position: relative;
    height: 100%;
    min-height: 200px;
    border-radius: 20px;
    background: #ffffff;
    border: 1px solid #f0f4f7;
    box-shadow:
        0 10px 30px rgba(0, 0, 0, 0.04),
        0 2px 10px rgba(0, 0, 0, 0.02);
    cursor: pointer;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    animation: fadeInUp 0.6s ease-out forwards;
    opacity: 0;
    transform: translateY(20px);
}

.client-card:hover {
    transform: translateY(-5px) scale(1.01);
    box-shadow:
        0 20px 40px rgba(0, 168, 150, 0.15),
        0 8px 16px rgba(0, 0, 0, 0.06);
}

.client-card:hover .hover-overlay {
    opacity: 1;
    visibility: visible;
}

.client-card:hover .avatar-glow {
    opacity: 0.6;
    transform: scale(1.2);
}

.client-card:hover .background-decoration {
    opacity: 0.1;
    transform: rotate(15deg) scale(1.1);
}

/* CARD CONTENT & ELEMENTS */
.card-content {
    position: relative;
    height: 100%;
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 2;
}

.background-decoration {
    position: absolute;
    top: -50%;
    right: -30%;
    width: 150px;
    height: 150px;
    background: #00A896;
    border-radius: 50%;
    opacity: 0.05;
    transition: all 0.4s ease;
    z-index: 1;
}

.avatar-container {
    position: relative;
    margin-bottom: 1.5rem;
}

.avatar-circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: linear-gradient(135deg, #00A896 0%, #00C6B7 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-shadow:
        0 6px 20px rgba(0, 168, 150, 0.4);
    transition: all 0.3s ease;
}

.avatar-inner {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    transition: all 0.3s ease;
}

.avatar-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 110px;
    height: 110px;
    background: radial-gradient(circle, rgba(0, 168, 150, 0.4) 0%, transparent 70%);
    border-radius: 50%;
    opacity: 0;
    transition: all 0.4s ease;
    z-index: -1;
}

.client-info {
    text-align: center;
    z-index: 2;
}

.client-name {
    font-size: 1.25rem;
    font-weight: 700;
    color: #333333;
    margin: 0 0 0.5rem 0;
    letter-spacing: -0.025em;
    line-height: 1.2;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.client-badge {
    display: inline-block;
    padding: 0.375rem 1rem;
    background: rgba(0, 168, 150, 0.1);
    color: #00A896;
    border-radius: 50px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: 1px solid rgba(0, 168, 150, 0.15);
}

.status-indicator {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 12px;
    height: 12px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-radius: 50%;
    box-shadow:
        0 0 0 3px rgba(16, 185, 129, 0.2),
        0 2px 4px rgba(0, 0, 0, 0.1);
}

/* HOVER OVERLAY STYLING */
.hover-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(0, 168, 150, 0.9) 0%, rgba(0, 198, 183, 0.9) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    z-index: 10;
}

.hover-content {
    text-align: center;
    color: white;
    transform: translateY(10px);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.client-card:hover .hover-content {
    transform: translateY(0);
}

.hover-content i {
    display: block;
    margin-bottom: 0.5rem;
    opacity: 0.9;
}

.hover-content span {
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.dossier-total {
    font-size: 1.25rem;
    font-weight: 700;
    margin-top: 0.5rem;
}

/* Animation d'apparition */
@keyframes fadeInUp {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive */
@media (max-width: 576px) {
    .card-content {
        padding: 1.5rem 1rem;
    }

    .avatar-circle {
        width: 80px;
        height: 80px;
    }

    .avatar-inner {
        width: 70px;
        height: 70px;
    }

    .client-name {
        font-size: 1.125rem;
        max-width: 150px;
    }
}
</style>